import AbsComponent from '../../common/components/AbsComponent';
import Utils from '../../common/Utils';
import Templ from './NshopTempl';

/**
 * Nshop class
 * @category mainApp
 */
class Nshop extends AbsComponent{
	constructor(_store = {}, _el = '') {
		super(_store, _el);

    $(this.el + ' .loading-wrap').show();
		this.store.getNshopData('Nshop', {}, this.render.bind(this));
	}


	render(_jsonData = {} ) {
		this.data = _jsonData;


		$(this.el + ' .loading-wrap').hide();
		
		$(this.el).append(Templ.getTempl(_jsonData, this.store.data.config.powerbookDomain ));

		const _myStoneCount =  _jsonData.NshopMygodstone.count || '0' ;
		$('.nshop-info > .count').append( Utils.addThousandSeparatorCommas( _myStoneCount) );

		this.setting();
		this.addEvents();

		if (this.store.getData('config').isLogin) {
			const serverType = (this.store.data.config.userData.representativeCharacter.serverType) ? this.store.data.config.userData.representativeCharacter.serverType.toLowerCase()+'server' : 'liveserver';
			// if (serverType == 'frontierserver'){
			// 	$('.nshop-info > .link').attr( 'href', `https://${window._serviceEnv=="RC" ? "rc-" : "" }bnsnshop.plaync.com/bnsr/goods/list?dci=206`);
			// 	$('.nshop-tab > span.tab-frontier').trigger('click');
			// }
		}


	}

	setting(){

		// $('.nshop-godstone.is-live').slick({
		// 	autoplay: true,
		// 	autoplaySpeed: 9000,
		// 	dots: true,
		// 	arrows: false,
		// 	infinite: true,
		// 	speed: 700,
		// 	slidesToShow: 1,
		// 	slidesToScroll: 1
		// });

		// $('.nshop-godstone.is-frontier').slick('slickPause');

		// $(window).on('resize orientationchange', function() {
		// 	$('.nshop-godstone.is-live').slick('resize');
		// });

	}
	addEvents(){

		$('.nshop-tab > span ').on('click', (e)=>{

			// let oldServerType = $('.nshop-tab > span.is-active').data('servertype');
			// let newServertype = $(e.currentTarget).data('servertype');
      //
			// $('.nshop-tab > span.tab-'+oldServerType).removeClass('is-active');
			// $('.nshop-godstone.is-'+oldServerType).removeClass('is-active');
      //
			// $('.nshop-tab > span.tab-'+newServertype).addClass('is-active');
			// $('.nshop-godstone.is-'+newServertype).addClass('is-active');
      //
			// $('.nshop-godstone.is-'+oldServerType).slick('slickPause');
			// $('.nshop-godstone.is-'+newServertype).slick('slickPlay');
			// $('.nshop-godstone.is-'+newServertype).slick('setPosition');

		});

	}
}

export default Nshop;